import React from 'react';
import {GET_CURRENT_PRIZE_INFO} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function QueryCurrentPrizeInfo (props) {
    const { loading, error, data} = useQuery(GET_CURRENT_PRIZE_INFO);
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;
    let Prize = data.getCurrentPrizeInfo.split('.')[0]
    let Year = data.getCurrentPrizeInfo.split('.')[1]
    return (
        <div className="FooterAllRightAwardText">
            <div>{Prize} Awards</div>
            <div>{Year}</div>
        </div>
    )}
export default QueryCurrentPrizeInfo